import * as React from 'react';

import {LatestOutreachListItem} from './latest-outreach-list-item';
import type {Edition} from './types';

import styles from './email-latest-outreach-list.module.css';

type Props = {
    editions: Edition[];
    isLoading: boolean;
    onViewUrl: (url: string) => void;
    onArchiveBroadcast: (id: string) => void;
};

export function EmailLatestOutreachList(props: Props) {
    return (
        <ul
            className={
                props.isLoading ? styles['list-container--loading'] : styles['list-container']
            }
        >
            {props.editions &&
                props.editions.map((edition) => {
                    return (
                        <li key={edition.id}>
                            <LatestOutreachListItem
                                edition={edition}
                                onView={(url) => {
                                    props.onViewUrl(url);
                                }}
                                archive={{
                                    onArchive: props.onArchiveBroadcast,
                                    shouldConfirm: false,
                                }}
                                // @ts-expect-error
                                backgroundColor={edition.backgroundColor}
                            />
                        </li>
                    );
                })}
        </ul>
    );
}
